// extracted by css-extract-rspack-plugin
export default {"container":"container_fbn8g","canvas":"canvas_cbb_j","canvasInvisible":"canvas-invisible_nRCAC"};